import { API_TAG_TYPES, baseApi } from "@/shared/api";
import type { CreateDemoOrgRequest, CreateDemoOrgResponse, ResetDemoResponse, SeedDemoResponse } from "../types";

const DEMO_SEED_TAGS = API_TAG_TYPES.filter((tag) => tag !== "Auth");

export const demoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createDemoOrg: builder.mutation<CreateDemoOrgResponse, CreateDemoOrgRequest>({
      query: (body) => ({
        url: "/api/demo/organizations/",
        method: "POST",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: ["Auth"],
    }),
    seedDemoData: builder.mutation<SeedDemoResponse, void>({
      query: () => ({
        url: "/api/demo/seed/",
        method: "POST",
        credentials: "include" as const,
      }),
      invalidatesTags: DEMO_SEED_TAGS,
    }),
    resetDemoData: builder.mutation<ResetDemoResponse, void>({
      query: () => ({
        url: "/api/demo/reset/",
        method: "POST",
        credentials: "include" as const,
      }),
      invalidatesTags: DEMO_SEED_TAGS,
    }),
  }),
});

export const { useCreateDemoOrgMutation, useSeedDemoDataMutation, useResetDemoDataMutation } = demoApi;
